<template>
  <rest-page ref="page" :fetch-endpoint="fetchEndpoint">
    <page-header :title="title" :breadcrumbs="breadcrumbs">
      <template v-if="!readonly" slot="actions">
        <el-button icon="ico icon-floppy" type="primary" @click="save">
          {{
            isEditPage
              ? $t('DataManager_Button_UpdateLocation')
              : $t('DataManager_Button_CreateLocation')
          }}
        </el-button>
      </template>
    </page-header>
    <page-content>
      <el-row>
        <el-col :span="12">
          <form-section>
            <rest-form
              v-if="model"
              ref="form"
              :save-endpoint="saveEndpoint"
              :after-save="afterSave"
              :model="model"
              :rules="{}"
              :validate-on-rule-change="false"
              :disabled="readonly"
            >
              <rest-form-item
                :label="$t('DataManager_Locations_Field_Title')"
                prop="title"
              >
                <el-input
                  v-model="model.title"
                  :placeholder="$t('DataManager_Locations_Field_Title')"
                />
              </rest-form-item>
              <rest-form-item
                prop="type"
                :label="$t('DataManager_Locations_Field_Type')"
              >
                <radio-group v-model="model.type" inline>
                  <el-radio :label="0" border :disabled="isEditPage">
                    {{ $t('DataManager_Locations_Field_GeoFence') }}
                  </el-radio>
                  <el-radio :label="2" border :disabled="isEditPage">
                    {{ $t('DataManager_Locations_Field_iBeacon') }}
                  </el-radio>
                </radio-group>
              </rest-form-item>

              <div
                v-if="
                  model.type === 0 ||
                    model.type === '0' ||
                    model.type === 2 ||
                    model.type === '2'
                "
              >
                <rest-form-item
                  prop="address"
                  :label="$t('DataManager_Locations_Field_Address')"
                >
                  <el-autocomplete
                    v-model="address"
                    :fetch-suggestions="addressQuerySearch"
                    :placeholder="$t('DataManager_Locations_Field_Address')"
                    :trigger-on-focus="false"
                    @select="addressHandleSelect"
                    ref="address"
                  />
                </rest-form-item>
                <rest-form-item
                  v-if="!isGeofence"
                  prop="ibeacon_uuid"
                  :label="$t('DataManager_Locations_Field_UUID')"
                >
                  <el-autocomplete
                    v-model="model.ibeacon_uuid"
                    :fetch-suggestions="UUIDQuerySearch"
                    :placeholder="$t('DataManager_Locations_Field_UUID')"
                  />
                </rest-form-item>
                <el-row>
                  <el-col :span="12">
                    <rest-form-item
                      v-if="!isGeofence"
                      prop="ibeacon_major"
                      :label="$t('DataManager_Locations_Field_iBeaconMajor')"
                    >
                      <el-input
                        v-model="model.ibeacon_major"
                        :placeholder="
                          $t('DataManager_Locations_Field_iBeaconMajor')
                        "
                      />
                    </rest-form-item>
                  </el-col>
                  <el-col :span="12">
                    <rest-form-item
                      v-if="!isGeofence"
                      prop="ibeacon_minor"
                      :label="$t('DataManager_Locations_Field_iBeaconMinor')"
                    >
                      <el-input
                        v-model="model.ibeacon_minor"
                        :placeholder="
                          $t('DataManager_Locations_Field_iBeaconMinor')
                        "
                      />
                    </rest-form-item>
                  </el-col>
                </el-row>
                <rest-form-item
                  prop="country"
                  :label="$t('DataManager_Locations_Field_Country')"
                >
                  <el-input
                    v-model="model.country"
                    :placeholder="$t('DataManager_Locations_Field_Country')"
                  />
                </rest-form-item>
                <rest-form-item
                  prop="radius"
                  :label="$t('DataManager_Locations_Field_Radius')"
                >
                  <el-slider
                    v-model="model.radius"
                    @change="updateRadius"
                    show-input
                    :min="isGeofence ? 100 : 1"
                    :max="isGeofence ? 50000 : 70"
                  ></el-slider>
                </rest-form-item>
                <rest-form-item
                  prop="groups_str"
                  :label="$t('DataManager_Locations_Field_Tags')"
                >
                  <el-select
                    v-model="model.tags"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    :placeholder="$t('DataManager_Locations_Field_Tags')"
                  >
                    <el-option
                      v-for="(item, index) in tags"
                      :key="index"
                      :label="item"
                      :value="index"
                    ></el-option>
                  </el-select>
                </rest-form-item>

                <page-section
                  :title="$t('DataManager_Locations_Title_Payloads')"
                >
                  <el-button
                    v-if="!readonly"
                    slot="controls"
                    size="mini"
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addPayload"
                  >
                    {{ $t('DataManager_Button_AddPayload') }}
                  </el-button>
                  <div v-if="model.payloads.length > 0">
                    <el-row
                      v-for="(item, index) in model.payloads"
                      :key="index"
                      class="payload-row"
                    >
                      <el-col :span="11">
                        <el-input
                          v-model="item.key"
                          size="mini"
                          :placeholder="$t('DataManager_Locations_Field_Key')"
                          :disabled="readonly"
                        ></el-input>
                      </el-col>
                      <el-col :span="11">
                        <el-input
                          v-model="item.value"
                          size="mini"
                          :placeholder="$t('DataManager_Locations_Field_Value')"
                          :disabled="readonly"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <i
                          class="el-icon-delete"
                          :title="
                            $t('DataManager_Locations_Text_DeletePayload')
                          "
                          @click="removePayload(item)"
                        ></i>
                      </el-col>
                    </el-row>
                  </div>
                  <p v-else class="no-results-found-text">
                    {{ $t('DataManager_Locations_Text_NoPayloads') }}
                  </p>
                </page-section>
              </div>
            </rest-form>
          </form-section>
        </el-col>
        <el-col :span="12">
          <location-map
            :project-id="projectId"
            :title="model.title"
            @update-address="updateAddress"
            @map-ready="refreshMap"
            :loading="mapLoading"
            ref="map"
          />
        </el-col>
      </el-row>
    </page-content>
  </rest-page>
</template>
<script>
import RestPage from '@/common/components/rest/RestPage'
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageContent from '@/common/components/page/PageContent'
import FormSection from '@/common/components/form/FormSection'
import RestForm from '@/common/components/rest/RestForm'
import RestFormItem from '@/common/components/rest/RestFormItem'
import RadioGroup from '@/common/components/form/RadioGroup'
import LocationMap from '@/modules/data-manager/components/DataManagerLocationsMap'
import PageSection from '@/common/components/page/PageSection'
import RestApi from '@/core/services/RestApi'
import LoadGoogleMaps from 'vendor/gmaps/loader'
import { projectEndpoint, projectRoute } from '@/core/helpers'
export default {
  name: 'DataManagerLocationPage',

  components: {
    RestPage,
    PageHeader,
    PageSection,
    PageContent,
    FormSection,
    RestForm,
    RestFormItem,
    RadioGroup,
    LocationMap
  },

  props: {
    readonly: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      model: this.defaultModel(),
      address: '',
      geometry: {},
      tags: [],
      mapLoading: true
    }
  },

  computed: {
    fetchEndpoint() {
      if (this.isEditPage) {
        return projectEndpoint({
          method: 'get',
          url: `locations/${this.$route.query.id}`,
          handler: data => {
            this.model = data
            if (this.model.tags.join() === '') {
              this.model.tags = []
            }
            this.address = this.model.address
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.isEditPage) {
        return projectEndpoint({
          method: 'patch',
          url: `locations/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `locations`
        })
      }
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('DataManager_Breadcrumb_Locations'),
          route: projectRoute({
            name: 'DataManagerLocations'
          })
        },
        {
          label: this.title
        }
      ]
    },

    projectId() {
      return this.$route.query.project_id
    },

    isGeofence() {
      return this.model.type === 0 || this.model.type === '0'
    },

    isEditPage() {
      return !!this.$route.query.id
    },

    title() {
      if (!this.readonly) {
        return this.isEditPage
          ? this.$t('DataManager_Breadcrumb_EditLocation')
          : this.$t('DataManager_Breadcrumb_CreateLocation')
      } else {
        return this.$t('DataManager_Breadcrumb_ViewLocation')
      }
    }
  },

  methods: {
    defaultModel() {
      if (this.isEditPage) {
        return null
      } else {
        return {
          payloads: []
        }
      }
    },

    addressQuerySearch(queryString, cb) {
      let geocoder = null
      let data = []
      LoadGoogleMaps(function(google) {
        geocoder = new google.maps.Geocoder()
        geocoder.geocode({ address: queryString }, results => {
          data = Object.keys(results).map(key => {
            return {
              label: results[key].formatted_address,
              value: results[key].formatted_address,
              geocode: results[key]
            }
          })
          cb(data)
        })
      })
    },

    UUIDQuerySearch(queryString, cb) {
      let params = {
        uuid: queryString
      }
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `ibeacon-uuids`,
          params: queryString !== '' ? params : null
        })
      ).then(({ data }) => {
        let list = data.map(item => {
          return {
            value: item.uuid
          }
        })
        cb(list)
      })
    },

    addressHandleSelect(item) {
      Object.assign(this.geometry, item.geocode.geometry)
      this.$refs.map.refreshMap(
        this.geometry.location.lat(),
        this.geometry.location.lng(),
        this.model.radius
      )
      this.$refs.map.setAddress(this.geometry)
    },

    updateRadius(radius) {
      if (this.isEditPage) {
        this.refreshMap()
      } else if (Object.keys(this.geometry).length > 0) {
        this.$refs.map.refreshMap(
          this.geometry.location.lat(),
          this.geometry.location.lng(),
          radius
        )
      }
    },

    updateAddress(locationId, address, countryName) {
      Object.assign(this.geometry, locationId)
      this.address = address
      this.$set(this.model, 'latitude', this.geometry.location.lat())
      this.$set(this.model, 'longitude', this.geometry.location.lng())
      this.$set(this.model, 'country', countryName)
    },

    refreshMap() {
      if (this.isEditPage) {
        this.$refs.map.refreshMap(
          this.model.latitude,
          this.model.longitude,
          this.model.radius
        )
      }
      this.mapLoading = false
    },

    save() {
      this.$set(this.model, 'address', this.address)
      this.model.groups_str = this.model.tags.join()
      this.$set(
        this.model,
        'payload_data',
        this.model.payloads.map(item => {
          return {
            key: item.key,
            value: item.value
          }
        })
      )
      this.$refs.form.save()
    },

    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'DataManagerLocations'
        })
      )
    },

    removePayload(item) {
      var index = this.model.payloads.indexOf(item)
      if (index !== -1) {
        this.model.payloads.splice(index, 1)
      }
    },

    addPayload() {
      this.model.payloads.push({
        key: '',
        value: '',
        project_id: this.model.project_id,
        location_id: this.model.id
      })
    }
  }
}
</script>
<style scoped>
>>> .content {
  background-color: #f8fafc;
  padding: 20px;
}

>>> .form-section {
  height: 880px;
  overflow-y: auto;
}

>>> .el-radio {
  background-color: #ffffff;
  border: 1px solid #dbdee7;
  border-radius: 4px;
  height: 48px;
}

i {
  cursor: pointer;
}

>>> .page-section > .header {
  margin-bottom: 0;
}

>>> .page-section > .header > .info > .title {
  font-size: 14px;
}

.no-results-found-text {
  font-size: 15px;
  color: #acb0b5;
  text-align: center;
}

.payload-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

>>> .el-slider__bar {
  background-color: #1d87c8;
}

>>> .el-slider__button {
  border: solid 2px #1d87c8;
}
</style>



// WEBPACK FOOTER //
// src/modules/data-manager/pages/DataManagerLocationPage.vue